import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OtaBatchViewComponent } from './ota-batch-view.component';

const routes: Routes = [
  {
    path: 'ota-batch-view',
    component: OtaBatchViewComponent,
  },
  {
    path: 'ota-batch-view/:otaRefId',
    component: OtaBatchViewComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtaBatchViewRoutingModule {}
